import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import Dashboard from "./screens/Dashboard";
import News from "./screens/News";
import Notes from "./screens/Notes";
import Chat from "./screens/Chat";
import ChatPages from "./screens/ChatPages";
import CricketGears from "./screens/CricketGears";
import NotesDetails from "./screens/NotesDetails";
import CreateNews from "./screens/CreateNews";
import CricketGearsList from "./screens/CricketGearsList";
import NewsDetails from "./screens/NewsDetails";
import Notification from "./screens/Notification";
import NotificationDetails from "./screens/NotificationDetails";
import Users from "./screens/Users";
import CreateNotification from "./screens/CreateNotification";
import Status from "./screens/Status";
import CreateStatus from "./screens/CreateStatus";
import StatusList from "./screens/StatusList";
import Signin from "./screens/Signin";
import { useSelector } from "react-redux";

function App() {
  const isLoggedIn = useSelector(state=>state.reducer.status)
  //console.log("isLoggedIn",isLoggedIn)
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Signin />} />
          {isLoggedIn ? <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<Users />} />
            <Route path="status" element={<Status />}>
              <Route path="statusDetails" element={<StatusList />} />
            </Route>

            <Route path="news" element={<News />}>
              <Route path="createNews" element={<CreateNews />} />
            </Route>
            <Route path="notes" element={<Notes />}>
              <Route path="notesDetails" element={<NotesDetails />} />
            </Route>
            <Route path="cricketGears" element={<CricketGears />}>
              <Route path="cricketGearsList" element={<CricketGearsList />} />
            </Route>
            <Route path="chats" element={<Chat />}>
              <Route path="chatpages" element={<ChatPages />} />
            </Route>
            <Route path="newsDetails" element={<NewsDetails />} />
            <Route path="notification" element={<Notification />}>
              <Route
                path="notificationDetails"
                element={<NotificationDetails />}
              />
            </Route>
            <Route path="create" element={<CreateNotification />} />
            <Route path="createStatus" element={<CreateStatus />} />
            <Route path="*" element={<h1>page not found error 404 !!</h1>} />
          </Route> : null}
          <Route path="*" element={<h1>page not found error 404 !!</h1>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
